// @ts-nocheck
import PropTypes from 'prop-types';
import { Phone, WhatsappLogo, EnvelopeSimple } from '@phosphor-icons/react';
import { openWhatsApp } from '../../helpers/contact';
import './ContactCard.css';

const ContactCard = ({
  name,
  description,
  phone,
  whatsapp,
  email,
  type = 'primary'
}) => {
  const handlePhoneCall = (phoneNumber) => {
    if (phoneNumber) {
      window.location.href = `tel:${phoneNumber.replace(/\s/g, '')}`;
    }
  };

  const handleWhatsApp = (whatsappNumber) => {
    if (whatsappNumber) {
      openWhatsApp(whatsappNumber);
    }
  };

  const handleEmail = (emailAddress) => {
    if (emailAddress) {
      window.location.href = `mailto:${emailAddress}`;
    }
  };

  return (
    <div className={`contact-card contact-card--${type}`}>
      <div className='contact-card__header'>
        <h3 className='contact-card__name'>{name}</h3>
        {description && (
          <p className='contact-card__description'>{description}</p>
        )}
      </div>

      <div className='contact-card__contacts'>
        {phone && (
          <button
            className='contact-card__contact-item'
            onClick={() => handlePhoneCall(phone)}
            aria-label={`Call ${name} at ${phone}`}
          >
            <Phone size={18} weight='regular' />
            <span>{phone}</span>
          </button>
        )}

        {whatsapp && (
          <button
            className='contact-card__contact-item'
            onClick={() => handleWhatsApp(whatsapp)}
            aria-label={`WhatsApp ${name} at ${whatsapp}`}
          >
            <WhatsappLogo size={18} weight='regular' />
            <span>WhatsApp: {whatsapp}</span>
          </button>
        )}

        {email && (
          <button
            className='contact-card__contact-item'
            onClick={() => handleEmail(email)}
            aria-label={`Email ${name} at ${email}`}
          >
            <EnvelopeSimple size={18} weight='regular' />
            <span>{email}</span>
          </button>
        )}
      </div>
    </div>
  );
};

ContactCard.propTypes = {
  name: PropTypes.string.isRequired,
  description: PropTypes.string,
  phone: PropTypes.string,
  whatsapp: PropTypes.string,
  email: PropTypes.string,
  type: PropTypes.oneOf(['primary', 'emergency', 'secondary'])
};

export default ContactCard;
